






































import { defineComponent } from "@vue/composition-api";
import { gtagTrackEventScrile } from "@/lib/analytics";
import { $t } from "@/lib/i18nHelpers";
import { loginEmail, olecamsLogin } from "@/lib/loginHelpers";
import { FormFields, FormValues } from "@/types";
import { ROLES } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import LoginContainer from "@/components/LoginContainer";

export default defineComponent({
  name: "LoginComponent",
  components: { BaseForm, BaseButton, LoginContainer },
  props: {
    safe: { type: Boolean, default: false },
    forceDarkTheme: { type: Boolean },
    role: { type: String, default: ROLES.MEMBER },
  },
  data() {
    return {
      values: {} as FormValues,
      loading: false,
      errorText: "",
      errorFields: [] as string[],
    };
  },
  computed: {
    fields(): FormFields {
      return [
        {
          name: "email",
          placeholder: $t("Your email"),
          autocomplete: "email",
          type: "email",
          invalidField: this.errorFields.includes("email"),
          forceDark: this.forceDarkTheme,
        },
        {
          name: "password",
          placeholder: $t("Enter a password"),
          autocomplete: "current-password",
          type: "password",
          invalidField: this.errorFields.includes("password"),
          forceDark: this.forceDarkTheme,
        },
      ];
    },
  },
  methods: {
    onInput(values: FormValues) {
      this.values = values;
      this.errorText = "";
      this.errorFields = [];
    },
    async submit() {
      this.errorText = "";
      this.errorFields = [];
      try {
        this.loading = true;
        let response;
        if (this.role === ROLES.CREATOR) {
          response = await loginEmail(this.values.email, this.values.password, this.safe);
        } else {
          response = await olecamsLogin(this.values.email, this.values.password, this.safe);
        }
        this.$emit("login");
        gtagTrackEventScrile("user_role_dimension", { user_role: response?.user.role });
      } catch (e) {
        this.errorFields.push("password", "email");
        this.errorText = $t("Invalid credentials. Please try again.");
      } finally {
        this.loading = false;
      }
    },
  },
});
